import { z } from "zod";
export const CustomDomain = z.object({
    id: z.string(),
    designSystemId: z.string(),
    state: z.string(),
    supernovaDomain: z.string(),
    customerDomain: z.string().nullish(),
    error: z.string().nullish(),
    errorCode: z.string().nullish(),
});
